import BackboneDeepModel from '@kahwee/backbone-deep-model';
import Errors from './../../base/errors.js';

export default BackboneDeepModel.extend({
  url: '',

  initialize() {
    this.on('error', (model, xhr, options) => {
      this.error(model, xhr, options);
    });
  },

  defaults: {},

  validation: {
    'SecurityInfo.SecurityQuestions.0.id': {
      required: true
    },
    'SecurityInfo.SecurityQuestions.0.answer': {
      required: true,
      maxLength: 100
    },
    'SecurityInfo.SecurityQuestions.1.id': {
      required: true
    },
    'SecurityInfo.SecurityQuestions.1.answer': {
      required: true,
      maxLength: 100
    },
    'SecurityInfo.SecurityQuestions.2.id': {
      required: true
    },
    'SecurityInfo.SecurityQuestions.2.answer': {
      required: true,
      maxLength: 100
    }
  },

  validate(attrs, options) {},

  parse(response, options) {
    return response;
  },

  error(model, xhr, options) {
    Errors.handleResponse(null, xhr, options);
  }
});
